// extracted by mini-css-extract-plugin
module.exports = {"inner":"EditorFooter_inner__2mnyX","errorLogs":"EditorFooter_errorLogs__1loZb"};